
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import { requiredRule } from "@/components/controls/catalogueGrid/columns/baseValidationRules";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { BooleanColumnConfig } from "@/components/controls/catalogueGrid/columns/booleanColumnConfig";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import { TableImportConfig } from "@/components/controls/catalogueGrid/tableImportConfig";
import { TableExportConfig } from "@/components/controls/catalogueGrid/tableExportConfig";
import PanelSelectionWorkflow from "@/components/workflows/panelSelection/panelSelectionWorkflow.vue";
import FilterDialog from "./FilterDialog.vue"
import api from "@/services/api";
import store from "@/store";

export default defineComponent({
  components: {
    CatalogueGrid,
    PanelSelectionWorkflow,
    FilterDialog,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
    //открыты ли настройки
    isSettingsOpen: { type: Object, required: true },
  },
  methods: {
    resetSelectedRows(){
      if (this.$refs.grid.dxGrid.getSelectedRowKeys){
        let selectedRowsKeys = this.$refs.grid.dxGrid.getSelectedRowKeys();
        for (var i = 0; i < selectedRowsKeys.length; i++) {  
          this.$refs.grid.dxGrid.deselectRows([selectedRowsKeys[i]]);  
        }
      }
      this.$refs.area.blur()
    },
    async applyFilter(filter: any){
      let dxGrid = this.$refs.grid.dxGrid;
      this.$refs.grid.updateAdditionalFilters(null);
      dxGrid.clearFilter("row");
      dxGrid.clearFilter("header");
      dxGrid.filter("FilterValues", "=", JSON.stringify(filter));
      const temp = {
        filter: JSON.stringify(filter),
        index: this.parentModel.id,
      };
      store.dispatch("panelFilter/setPanelFilter", temp);
      this.isFilter = true;
    },
    resetFilter(){
      this.$refs.grid.updateAdditionalFilters(null);
      this.$refs.grid.dxGrid.clearFilter("dataSource");
      const temp = {
        filter: null,
        index: this.parentModel.id,
      };
      store.dispatch("panelFilter/setPanelFilter", temp);
      this.isFilter = false;
    },
    showFilterDialog(){
      this.$refs.filterDialog.show(true);
    },
    getScrollSettings(){
      const panelSettings = (store as any).state.panelSettings.panelSettings[
        this.parentModel.id
      ];
      if (panelSettings) {
        this.designConfig.horizontalScroll = panelSettings.scroll;
      }
    },
    rememberScrollSettings(scroll: any) {
      const temp = {
        settings: {
          scroll: scroll,
        },
        index: this.parentModel.id,
      };
      store.dispatch("panelSettings/setPanelSettings", temp);
    },
    onRowValidating(e) {
      if(e.newData.minLength || e.newData.maxLength){
        let min = e.newData.minLength ? e.newData.minLength : e.oldData.minLength
        let max = e.newData.maxLength ? e.newData.maxLength : e.oldData.maxLength
        if (min > max){
          e.errorText = "Значение максимальной длины не может быть меньше минимальной";
          e.isValid = false;
        }
      }
    },
    onUpdateParentModelCallback() {
      const grid = this.$refs.grid.dxGrid;
      this.updateSelectionButton(grid);
    },
    onStartPanelSelection() {
      (this.$refs.panelSelectionWorkflow as any).start(this.parentModel?.id);
    },
    onDataFillApply() {
      const grid = this.$refs.grid.dxGrid;
      this.updateSelectionButton(grid);
    },
    onImportClose() {
      const grid = this.$refs.grid.dxGrid;
      this.updateSelectionButton(grid);
    },
    onSelectionClose() {
      const grid = this.$refs.grid.dxGrid;
      this.updateSelectionButton(grid);
      grid.columnOption("isSelectedForPlanning", "filterValue", true);
      grid.refresh();
    },
    async onToolbarPreparing(e: any) {
      if (this.repaintPreventKey) return;
      this.repaintPreventKey = true;
      this.panelSelectionButton = e.toolbarOptions.items.filter(
        (x: any) =>
          x.options && x.options.name === this.panelSelectionButtonName
      )[0];

      this.updateSelectionButton(e.component);
    },
    onRowInserted(e: any) {
      this.updateSelectionButton(e.component);
    },
    onRowUpdated(e: any) {
      this.updateSelectionButton(e.component);
    },
    onRowsRemoved(e: any) {
      this.updateSelectionButton(e.component);
    },
    changeCheckBox(value: any) {
      this.columns.pop();
      this.columns.push(
        new BooleanColumnConfig({
          dataField: "isSelectedForPlanning",
          caption: "Выбран для планирования",
          disabled: value,
        })
      );
    },
    onEditingStart() {
      this.changeCheckBox(false);
    },
    onEditCanceling() {
      this.changeCheckBox(true);
    },
    onInitNewRow() {
      this.changeCheckBox(false);
    },
    saving() {
      this.changeCheckBox(true);
    },
    async updateSelectionButton(grid: any) {
      if (this.isCalculation) return;
      const { data } = await api.get("Plan/IsStartPackageSelectionActive", {
        params: {
          planId: this.parentModel.id,
        },
      });
      this.repaintPreventKey = true;
      this.panelSelectionButton.options.disabled = !data;
      if (this.isCalculation === true) {
        this.panelSelectionButton.options.disabled = true;
      }
      grid.repaint();
    },
  },
  data() {
    return {
      additionalFilters: null,
      isFilter: false,
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "position",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "WeightSummary",
            showInColumn: "weight",
            column: "weight",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} т.",
            summaryType: "sum",
          },

          {
            name: "TotalWeightSummary",
            showInColumn: "totalWeight",
            column: "totalWeight",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} т",
            summaryType: "sum",
          },

          {
            name: "VolumeSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} м³",
            summaryType: "sum",
          },

          {
            name: "TotalVolumeSummary",
            showInColumn: "totalVolume",
            column: "totalVolume",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} м³",
            summaryType: "sum",
          },

          {
            name: "CountSummary",
            showInColumn: "count",
            column: "count",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
        ],
        groupItems: [
          {
            name: "GroupSummary",
            showInColumn: "position",
            displayFormat: "Итог:",
            summaryType: "custom",
            showInGroupFooter: "true",
          },

          {
            name: "WeightGroupSummary",
            showInColumn: "weight",
            column: "weight",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} т.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "TotalWeightGroupSummary",
            showInColumn: "totalWeight",
            column: "totalWeight",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} т",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "VolumeGroupSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} м³",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "TotalVolumeGroupSummary",
            showInColumn: "totalVolume",
            column: "totalVolume",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} м³",
            summaryType: "sum",
            showInGroupFooter: "true",
          },

          {
            name: "CountGroupSummary",
            showInColumn: "count",
            column: "count",
            valueFormat: "#,##0.#",  
            displayFormat: "{0} шт.",
            summaryType: "sum",
            showInGroupFooter: "true",
          },         
        ],
      },

      editingConfig: new TableEditingConfig({
        allowDeleteAll: !this.isCalculation,
        allowUpdating: !this.isCalculation,
        allowAdding: !this.isCalculation,
        allowDeleting: !this.isCalculation,
        confirmDelete: true,
        allowDataFill: !this.isCalculation,
        allowExport: true,
        allowImport: !this.isCalculation,
        allowClearFilter: true,
        allowCopy: true,
        allowDeleteMultipleRows: true,
        allowChangeScrollSettings: true,
        allowColumnReordering: true,
        allowGrouping: true,
        enableMasterDetail: true,
        detailComponentName:
          "components/journals/PlanPanelJournal/PlanPanelDetail.vue",
        mode: "row",
        chooseColumns: true,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        heightScroll: "calc(100vh - 350px)",
        horizontalScroll: true,
      }),
      columns: [
        new TextColumnConfig({
          dataField: "position",
          caption: "Позиция",
          validationRules: [requiredRule],
        }),

        new TextColumnConfig({
          dataField: "type",
          caption: "Тип панели",
          validationRules: [requiredRule],
        }),

        new TextColumnConfig({
          dataField: "quality",
          caption: "Качество",
          validationRules: [requiredRule],
        }),

        new IntegerColumnConfig({
          dataField: "height",
          caption: "Толщина (мм)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "width",
          caption: "Ширина (мм)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "length",
          caption: "Длина (мм)",
          min: 0,
        }),

        new IntegerColumnConfig({
          dataField: "count",
          caption: "Кол-во (шт)",
          min: 0,
        }),

        new DecimalColumnConfig({
          dataField: "weight",
          caption: "Вес (кг)",
          decimalPoints: 1,
          validationRules: [requiredRule]
        }),

        new DecimalColumnConfig({
          dataField: "totalWeight",
          caption: "Общий вес (кг)",
          decimalPoints: 1,
          readOnly: true,
        }),

        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 2,
          validationRules: [requiredRule],
        }),

        new DecimalColumnConfig({
          dataField: "totalVolume",
          caption: "Общий объем (м³)",
          decimalPoints: 2,
          readOnly: true,
        }),

        new IntegerColumnConfig({
          dataField: "machineNumber",
          caption: "№ машины",
          min: 0,
        }),

        new TextColumnConfig({
          dataField: "geometry",
          caption: "Геометрия",
        }),

        new TextColumnConfig({
          dataField: "appropriateOrderNomenclatures",
          caption: "Позиции заказа",
          readOnly: true,
        }),

        new BooleanColumnConfig({
          dataField: "isSelectedForPlanning",
          caption: "Выбран для планирования",
        }),
      ],
      importConfig: new TableImportConfig({
        progressMethodName: "importPlanPackageProgress",
        progressEventName: "importPlanPackageProgressEvent",
        messageEventName: "importPlanPackageMessageEvent",
      }),
      exportConfig: new TableExportConfig({
        progressMethodName: "exportPlanPackageProgress",
        progressEventName: "exportPlanPackageProgressEvent",
        messageEventName: "exportPlanPackageMessageEvent",
        exportFileName: "Панели-Opti-Loading",
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "multiple",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
      panelSelectionButton: {},
      panelSelectionButtonName: "panelSelectionButton",
      repaintPreventKey: false,
      toolbarItems: this.isCalculation
        ? []
        : [
            {
              location: "before",
              widget: "dxButton",
              options: {
                name: "panelSelectionButton",
                icon: "check",
                hint: "Подбор панелей по заказам",
                stylingMode: "text",
                onClick: this.onStartPanelSelection,
                disabled: true,
              },
            },
            {
              location: "before",
              widget: "dxButton",
              options: {
                name: "propertyFilterButton",
                icon: "filter",
                hint: "Фильтр по свойствам панелей",
                stylingMode: "text",
                onClick: this.showFilterDialog,
              },
            },
          ],
    };
  },
  created() {
    this.getScrollSettings();
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
    let filter = (store as any).state.panelFilter.panelFilter[this.parentModel.id];
    if (filter){
      this.additionalFilters = []
      this.additionalFilters.push("FilterValues", "=", filter)
      this.isFilter = true;
    }
  },
});
